export const ApiKeyLOADING = "apiKey/Loading";
export const ApiKeyERROR = "apiKey/Error";
export const ApiKeyListSUCCESS = "apiKey/ListSuccess";
export const ApiKeyCreateSUCCESS = "apiKey/CreateSuccess";
export const ApiKeyDeleteSUCCESS = "apiKey/DeleteSuccess";
